export default __webpack_public_path__ + "static/media/premium_beta.4cab85cf.svg";